import { render, staticRenderFns } from "./modalCreateView.vue?vue&type=template&id=6853ff3d"
import script from "./modalCreateView.vue?vue&type=script&lang=js"
export * from "./modalCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports